import keys from 'constants/keys'
/** Menu-only sentinel; API subtasks always use IMAGE_SUBTASK plus is_ai_enhanced. */
export const AI_IMAGE_BUTTON_TYPE = -100

export const subtaskTypeKeys: Record<
  number,
  'photo' | 'video' | 'question' | 'poll' | 'quiz' | 'link' | 'description' | 'ai'
> = {
  [keys.SUBTASK_TYPES.IMAGE_SUBTASK]: 'photo',
  [keys.SUBTASK_TYPES.VIDEO_SUBTASKS]: 'video',
  [keys.SUBTASK_TYPES.OPEN_QUESTION]: 'question',
  [keys.SUBTASK_TYPES.POLL_SUBTASK]: 'poll',
  [keys.SUBTASK_TYPES.PRIVATE_POLL]: 'quiz',
  [keys.SUBTASK_TYPES.LINK_SUBTASK]: 'link',
  [keys.SUBTASK_TYPES.DESCRIPTION]: 'description',
  [AI_IMAGE_BUTTON_TYPE]: 'ai',
}
